import { useMemo, useState } from "react";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CloseIcon from "@material-ui/icons/Close";
import FormulaIcon from "../../../images/formula.png";
import MathEditor from "../../MathEditor/MathEditor";

export function FieldInput({
  index,
  totalFields,
  type,
  questionType,
  field,
  handleCorrectInput,
  handleInput,
  uploadFile,
  remove,
}) {
  const [openEditor, setOpenEditor] = useState(false);

  const isInputType = useMemo(() => {
    return ["fillup", "oneword", "descriptive"].includes(questionType);
  }, [questionType]);

  const isCheckType = useMemo(() => {
    return ["mcq", "correctstatement", "assertion-reasoning"].includes(
      questionType
    );
  }, [questionType]);

  const { optionId, imageId } = useMemo(() => {
    const id = index + 1;
    return { optionId: `op${id}`, imageId: `image${id}` };
  }, [index]);

  const save = (value) => {
    handleInput(optionId, "value", value);
    setOpenEditor(false);
  };

  return (
    <>
      <div className="add_option_section">
        <div className="form-check styleRadio">
          <input
            className="form-check-input"
            type={type}
            name={isCheckType ? "mcq" : ""}
            id={`${optionId}_${field.value}`}
            onClick={handleCorrectInput}
            checked={isInputType ? true : null}
            style={{
              display: isInputType ? "none" : "",
            }}
          />
        </div>
        <div className="input-group mb-3 input-attach-group">
          {questionType === "descriptive" ? (
            <textarea
              type="text"
              className="form-control"
              placeholder={"Write answer"}
              name="value"
              id={optionId}
              value={field.value}
              onChange={(e) =>
                handleInput(optionId, e.target.name, e.target.value)
              }
            />
          ) : (
            <input
              type="text"
              className="form-control"
              placeholder={"Write answer"}
              name="value"
              id={optionId}
              value={field.value}
              onChange={(e) =>
                handleInput(optionId, e.target.name, e.target.value)
              }
            />
          )}
          <label htmlFor={imageId}>
            <AttachFileIcon className="attach_icon" />
          </label>
          <input
            style={{ display: "none" }}
            id={imageId}
            type="file"
            onChange={(e) => uploadFile(e, optionId)}
          />
        </div>
          <img onClick={() => setOpenEditor(true)} src={FormulaIcon} alt="formula" style={{width:"20px",height:"fit-content",margin:"auto",cursor:"pointer"}}/>
        {totalFields !== 1 && (
          <CloseIcon className="cancelOption" onClick={remove} />
        )}
      </div>
      {openEditor ? (
        <MathEditor
          closeEditor={() => setOpenEditor(false)}
          initialHtml={field.value}
          saveEditor={save}
        />
      ) : null}
    </>
  );
}
